/* =============================================================
   Select Anime — Product share button
   <sa-share-button data-share-url="..." data-share-title="...">

   Behavior:
   - Touch devices with the Web Share API: opens the native share
     sheet with { title, url } only — no image is attached.
   - Otherwise: toggles a small popover with X / Facebook / Reddit
     intent links (pre-built in Liquid, title + URL only) and a
     "Copy link" action.

   Loaded with defer from the snippet; guarded so a duplicate
   script tag cannot register the element twice.
   ============================================================= */
(function () {
  'use strict';

  if (window.customElements && customElements.get('sa-share-button')) return;

  var OPEN_CLASS = 'sa-share--open';

  function SAShareButton() {
    return Reflect.construct(HTMLElement, [], SAShareButton);
  }
  SAShareButton.prototype = Object.create(HTMLElement.prototype);
  SAShareButton.prototype.constructor = SAShareButton;

  SAShareButton.prototype.connectedCallback = function () {
    if (this._wired) return;
    this._wired = true;

    var self = this;
    this._btn = this.querySelector('.sa-share__btn');
    this._menu = this.querySelector('.sa-share__menu');
    this._copy = this.querySelector('[data-share-copy]');
    if (!this._btn || !this._menu) return;

    this._btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = self.getAttribute('data-share-url') || window.location.href;
      var title = self.getAttribute('data-share-title') || document.title;
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (navigator.share && coarse) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      self._toggle(self._menu.hidden);
    });

    if (this._copy) {
      this._copy.addEventListener('click', function () {
        var url = self.getAttribute('data-share-url') || window.location.href;
        var done = function () {
          var label = self._copy.getAttribute('data-label-copied') || 'Link copied';
          self._copy.textContent = label;
          self._copy.classList.add('sa-share__item--copied');
          window.setTimeout(function () {
            var idle = self._copy.getAttribute('data-label-copy') || 'Copy link';
            self._copy.textContent = idle;
            self._copy.classList.remove('sa-share__item--copied');
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () {});
        }
      });
    }

    this._onDocClick = function (e) {
      if (!self._menu.hidden && !self.contains(e.target)) self._toggle(false);
    };
    this._onKeydown = function (e) {
      if (e.key === 'Escape' && !self._menu.hidden) {
        self._toggle(false);
        self._btn.focus();
      }
    };
    document.addEventListener('click', this._onDocClick);
    document.addEventListener('keydown', this._onKeydown);
  };

  SAShareButton.prototype.disconnectedCallback = function () {
    if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
    if (this._onKeydown) document.removeEventListener('keydown', this._onKeydown);
    this._wired = false;
  };

  SAShareButton.prototype._toggle = function (open) {
    this._menu.hidden = !open;
    this.classList.toggle(OPEN_CLASS, !!open);
    if (this._btn) this._btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  if (window.customElements) customElements.define('sa-share-button', SAShareButton);
})();
